import { SwiperInit } from '../utilities/swiper-element'
import { addToCartFromCard } from '../utilities/form-product'

const handleIntersection = (entries, observer) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return

    observer.unobserve(entry.target)
    handleDataFetch(entry.target)
  })
}

const handleDataFetch = (section) => {
  const url = section.dataset.url

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div")
      html.innerHTML = text

      const recommendations = html.querySelector(".product-recommendations")
      if (recommendations && recommendations.innerHTML.trim().length) {
        const parentSection = section.closest('.shopify-section')
        parentSection.classList.add('u-hide')
        section.innerHTML = recommendations.innerHTML
        new SwiperInit()
        addToCartFromCard()
        setTimeout(() => {
          parentSection.classList.remove('u-hide')
        }, 1000)
      }
    })
    .catch((e) => {
      console.error(e)
    })
}

const productRecommendationsSections = document.querySelectorAll(".product-recommendations")
const observer = new IntersectionObserver(handleIntersection, {
  rootMargin: "0px 0px 200px 0px",
})

productRecommendationsSections.forEach(section => {
  observer.observe(section)
})

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    productRecommendationsSections.forEach(section => {
      handleDataFetch(section)
    })
  })
}
